<script setup>
import { useSidebar } from '@/hooks/useSidebar'
import { useAuthStore } from '@/stores/useAuthStore'
import { useSidebarStore } from '@/stores/useSidebarStore'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const { toggleMiniSidebar } = useSidebarStore()
const router = useRouter()

const { shouldRenderSidebar } = useSidebar()

async function handleLogout() {
  await authStore.logout()
  router.replace('/login')
}
</script>

<template>
  <v-app-bar :elevation="2" color="white">
    <template #prepend>
      <v-app-bar-nav-icon v-if="shouldRenderSidebar" @click="toggleMiniSidebar()" />
    </template>
    <v-app-bar-title class="d-flex align-center">
      <img
        src="/assets/app-logo.png"
        alt="Logo"
        style="height: 30px; max-height: 30px; object-fit: contain; margin-right: 18px"
      />
      <span style="line-height: 32px">AiGen</span>
    </v-app-bar-title>

    <v-spacer />

    <v-menu transition="slide-y-transition">
      <template #activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list style="min-width: 280px">
        <!-- User Info Section -->
        <v-list-item>
          <div class="pa-2">
            <div class="text-subtitle2 font-weight-bold mb-1">
              {{ authStore.user?.username || 'User' }}
            </div>
            <div class="text-caption text-medium-emphasis">
              {{ authStore.user?.email }}
            </div>
            <v-chip size="small" class="mt-2">
              {{ authStore.mappedUser?.role || 'Unknown' }}
            </v-chip>
          </div>
        </v-list-item>
        <v-divider />
        <!-- Logout -->
        <v-list-item key="logout" @click="handleLogout()">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
